/**
 *
 * Instructions for use can be found in
 * alertFactrory.service
 *
 *
 */
import { Component, Inject, Input} from 'ng-metadata/core';
import {IGeneralAlertMsg} from './alertMsg.interface';
import {AlertBarService} from './alertBar.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {ALERT_MSG_TYPE} from './alertFactory.service';
import {MediaQueries} from '../../mediaQueries.service';



@Component({
	'selector': 'prm-alert-bar',
	templateUrl: 'components/infra/widgets/alerts/alert-bar.html',
})

export class PrmAlertBar{

	/* input fields */
	@Input() public alertObject :IGeneralAlertMsg; 
@Input() public idpLogout : boolean;

	constructor(@Inject('$sce') private $sce, 
                @Inject('$compile') private $compile, 
                @Inject('favoritesIcons') public favoritesIcons, 
                private alertBarService: AlertBarService, 
                private jwtUtilService: JwtUtilService, 
                private configurationUtil: ConfigurationUtil, 
                private mediaQueries: MediaQueries){
	}

	get templateSrc(){
		switch(this.alertObject.getType()) {
			case ALERT_MSG_TYPE.SIGNIN: return 'components/infra/widgets/alerts/alertTemplates/signIn.html';
            case ALERT_MSG_TYPE.REQUEST: return 'components/infra/widgets/alerts/alertTemplates/requestAlert.html';
            case ALERT_MSG_TYPE.SIMPLE: return 'components/infra/widgets/alerts/alertTemplates/simple.html';
            case ALERT_MSG_TYPE.SIMPLE_WITHOUT_DISMISS: return 'components/infra/widgets/alerts/alertTemplates/simpleWithoutDismiss.html';
            case ALERT_MSG_TYPE.BROWSE_GAP: return 'components/infra/widgets/alerts/alertTemplates/simpleWithoutDismiss.html';
			default: return 'components/infra/widgets/alerts/alertTemplates/general.html';

		}
	}

	get htmlMsg() :string{
		if(this.alertObject) {
			return this.alertObject.getMsgHtml();
		}
		return null;
	}

	get msgValues() :object{
		return this.alertObject.getMsgValues();
	}


	private clearMessageSessionEnabled(){
		switch(this.alertObject.getType()) {
			case ALERT_MSG_TYPE.SIGNIN: return true;
			default: return false;

		}
	}

	public onClose(){
		if(this.clearMessageSessionEnabled()){
			let key = this.alertObject.getType() + '_clearClicked';
			this.alertBarService.messageShouldDisplay(key,true);
		}

		this.alertObject.hide();
	}

	public showMessage(){
		if(this.clearMessageSessionEnabled()){
			let key = this.alertObject.getType() + '_clearClicked';
			return this.alertBarService.messageShouldDisplay(key,null);
		}
		return undefined;
	}

    public isGuestOrOffcampusForSignIn(){

    	if (this.alertObject && this.alertObject.getAlwaysOn()) {
    		return true;
    	}

        let isGuest = this.jwtUtilService.isGuest();
        let isOffCampus = this.jwtUtilService.getDecodedToken().onCampus !== 'true';

        let groupMsg:number = this.configurationUtil.getBriefResultConfiguration().groupmessage;
        let isToDisplay:boolean = this.configurationUtil.getBriefResultConfiguration().displaysigninmsg;
        //when the message should be displayed - configuration + state:
        if (isToDisplay) {
            return ((groupMsg === 0 && isGuest) || (groupMsg === 1 && isOffCampus));
        }
        return false;
	}

	private isSignInAndPartialAlma() {
		return this.alertObject.getType() === ALERT_MSG_TYPE.SIGNIN  && this.configurationUtil.isPartialAlma();
	}

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/alertBar.directive.ts